/* eslint-disable */
import { types } from 'mobx-state-tree';
import SavedTab from '../SavedTab';
import Search from '../Search';
import User from '../User';
import Actions from './Actions';
import Views from './Views';
const StoreProps = {
    isInitialized: types.optional(types.boolean, false),
    user: types.optional(User, () => User.create()),
    prospecting: types.maybe(Search),
    search: types.maybe(Search),
    savedTab: types.optional(SavedTab, () => SavedTab.create()),
};
const RootStoreModel = types.model(StoreProps).actions(Actions).views(Views);
const rootStore = RootStoreModel.create({});
export default rootStore;
export { RootStoreModel };
